export const horseExamRequirementQueryKeys = {
  all: (): string => "horse-exam-requirement",
  list: (): string => "horse-exam-requirement:list"
};
